import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, AddDiscountClickBiEvent } from '@wix/da-bi/pkg/events';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import SellerDiscountModal from '../SellerDiscountModal';

import s from './EmptyDiscountList.scss';

interface Props {}

const EmptyDiscountList: FC<Props> = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Section className={s['root']}>
      <img
        src="https://st.deviantart.net/eclipse/empty-states/il6.1.19-discount.svg"
        alt={t('studio.earnings.emptyList.alt')}
      />
      <Heading className={s['header']}>{t('studio.discounts.emptyState.header')}</Heading>
      <div className={s['subheader']}>{t('studio.discounts.emptyState.subheader')}</div>
      <SolidButton
        className={s['button']}
        size="medium"
        variant="approval-green"
        priority="primary"
        icon={AddIcon}
        onClick={() => setIsModalOpen(true)}
        biData={BiData<AddDiscountClickBiEvent>({
          evid: 450,
          sectionname: 'empty_state',
        })}
      >
        {t('studio.header.tabs.discounts.addDiscount')}
      </SolidButton>
      {isModalOpen && <SellerDiscountModal onRequestClose={() => setIsModalOpen(false)} />}
    </Section>
  );
};
EmptyDiscountList.displayName = 'EmptyDiscountList';

export default EmptyDiscountList;
